const ENV_REACT_APP = {
    REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "",
    REACT_APP_ENV: process.env.REACT_APP_ENV || "",
    NODE_ENV: process.env.NODE_ENV || "",
    REACT_APP_HOST: process.env.REACT_APP_HOST || "",
    REACT_APP_PORT: process.env.REACT_APP_PORT || "",
    // Single Google Maps Platform key used for Static Maps (satellite) +
    // Street View Static + Street View metadata. Restrict via API
    // restrictions in GCP so it can't be abused if scraped from the
    // bundle (it WILL appear in the bundle — same as the Maps JS key).
    REACT_APP_GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
}

export { ENV_REACT_APP }